import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import * as Sentry from '@sentry/browser';
import braintree from 'braintree-web';
import $ from 'jquery';
import Button from 'components/Button/Button.react';
import styles from './Billing.scss';

class CreditCardInfo extends Component {
  state = {
    disabled: true,
  }

  components = {};

  async componentDidMount() {
    const { currentUser } = this.props;
    const email = currentUser.email;

    const client = {
      email,
    }

    const { clientToken } = await SashiDo.getBraintreeClientToken();
    this.setState({ client }, () => {
      this.onFetchClientToken(clientToken);
    })
  }

  onFetchClientToken = (clientToken) => {
    braintree.client.create({
      authorization: clientToken,
    }, this.onClientCreate);
  }

  onClientCreate = (err, client) => {
    this.components.client = client;

    braintree.hostedFields.create({
      client,
      styles: {
        input: {
          'font-size': '16px',
          'color': '#555572',
          'font-family': "'Ubuntu', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        },
      },
      fields: {
        number: {
          selector: '#cc-number',
          placeholder: ''
        },
        cvv: {
          selector: '#cc-cvv',
          placeholder: ''
        },
        expirationDate: {
          selector: '#cc-expiration',
          placeholder: '',
        },
        // postalCode: {
        //   selector: '#cc-postal-code',
        //   placeholder: '',
        //   prefill: this.state.client.billingAddress.postalCode
        // },
      },
    }, (err, hostedFieldsInstance) => {
      if (err) {
        console.error('@@@ ERROR @@@', err);

        SashiDo.saveInBillingLog({
          data: {
            user: this.state.client.email,
            error: err,
          }
        });
        return;
      }

      // Emulates floating label pattern
      hostedFieldsInstance.on('blur', (event) => {
        const field = event.fields[event.emittedBy];
        const el = $(field.container).parent();

        if (field.isValid) {
          el.removeClass(styles.invalid);
        } else {
          el.addClass(styles.invalid);
        }
        canSave();
      });

      hostedFieldsInstance.on('empty', (event) => {
        const field = event.fields[event.emittedBy];
        const el = $(field.container).parent();

        el.addClass(styles.invalid);
        canSave();
      });

      hostedFieldsInstance.on('validityChange', (event) => {
        const field = event.fields[event.emittedBy];
        const el = $(field.container).parent();

        if (field.isPotentiallyValid) {
          el.removeClass(styles.invalid);
        } else {
          el.addClass(styles.invalid);
        }
        canSave();
      });

      const ccName = $('#cc-name');

      ccName.on('change', () => {
        if (!ccName.val().trim()) {
          ccName.parent().addClass(styles.invalid);
          canSave();

          return null;
        }

        canSave();

        ccName.parent().removeClass(styles.invalid);
      });


      const canSave = () => {
        const state = hostedFieldsInstance.getState();
        const allValid = Object.keys(state.fields).filter(f => !state.fields[f].isValid);

        if (allValid.length === 0 && ccName.val().trim()) {
          this.setState({ disabled: false });

          return
        }

        this.setState({ disabled: true });
      }


      this.components['hostedFields'] = hostedFieldsInstance;
    });

    braintree.threeDSecure.create({
      client,
      version: 2,
    }, this.onComponent('threeDSecure'));

    const { handleLoading } = this.props;
    setTimeout(() => {
      handleLoading(false);
    }, 1000);
  }

  onComponent = (name) => {
    return (err, component) => {
      if (err) {
        // console.error('@@@ ERROR @@@', err);

        SashiDo.saveInBillingLog({
          data: {
            user: this.state.client.email,
            error: err,
          }
        });

        Sentry.withScope((scope) => {
          scope.setExtras("Billing", "threeDSecure");

          Sentry.captureException(err);
        });
      }

      this.components[name] = component;
    }
  }

  addFrame = (err, iframe) => {
    this.popup.append(iframe);
  }

  removeFrame = () => {
    this.popup.innerHTML = ''
  }

  onClickHandler = async () => {
    const { client } = this.state;
    const { handleLoading } = this.props;

    handleLoading(true);

    let ipAddress = undefined;

    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      ipAddress = data.ip;
    } catch (error) {
      console.error('Error fetching IP:', error);
    }

    const workPhoneNumber = (this.props.userInfo.phone.value || '').replace(/[^\d]/g, '');
    const shippingGivenName = this.props.userInfo.name.value;

    this.components.hostedFields.tokenize((err, payload) => {
      this.components.threeDSecure.verifyCard({
        onLookupComplete: (data, next) => {
          next();
        },
        addFrame: this.addFrame,
        removeFrame: this.removeFrame,
        amount: 1.00,
        challengeRequested: true,
        nonce: payload.nonce,
        collectDeviceData: true,
        additionalInformation: {
          workPhoneNumber,
          shippingGivenName,
          ipAddress,
        },
        ...client,
      }).then((payload) => {
        const { onSuccess, onError } = this.props;
        if (!payload.liabilityShifted) {
          SashiDo.saveInBillingLog({
            data: {
              user: client.email,
              payload,
            }
          });

          Sentry.withScope((scope) => {
            scope.setExtras("Billing", "threeDSecure");

            Sentry.captureException(payload);
          });

          onError('Liability did not shift');
          return;
        }

        onSuccess(payload);
      }).catch((err) => {
        // console.error('@@@ ERROR @@@', err);
        SashiDo.saveInBillingLog({
          data: {
            user: client.email,
            error: err,
          }
        });

        Sentry.withScope((scope) => {
          scope.setExtras("Billing", "threeDSecure");

          Sentry.captureException(err);
        });

        const { onError } = this.props;
        onError(err.message);
      });
    });
  }

  onFocus = event => {
    if (event.target.autocomplete) {
      event.target.autocomplete = "whatever";
    }
  };

  render() {
    let disabled = false;

    if (!this.props.allFieldsAreValid || this.state.disabled) {
      disabled = true;
    }

    return (
      <div>
        <div className={styles.ccBox}>
          <div className={styles.ccRows}>
            <div className={styles.ccRow}>
              <div className={[styles.inputHolder, styles.invalid].join(' ')}>
                <label htmlFor="cc-number">Credit card number</label>
                <div className={styles.input} id="cc-number" />
              </div>
              <div className={[styles.inputHolder, styles.invalid].join(' ')}>
                <label htmlFor="cc-expiration">Expiration</label>
                <div className={styles.input} id="cc-expiration" />
              </div>
            </div>
          </div>

          <div className={styles.ccRows}>
            <div className={styles.ccRow}>
              <div className={[styles.inputHolder, styles.invalid].join(' ')}>
                <label htmlFor="cc-cvv">CVV</label>
                <div className={styles.input} id="cc-cvv" />
              </div>
              <div className={[styles.inputHolder, styles.invalid].join(' ')}>
                <label htmlFor="cc-name">Card Holder</label>
                <input type="text" id="cc-name" className={styles.input} name="cc-holder" onFocus={this.onFocus} autoComplete="off" />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.hr} />

        <div className={[styles.box, styles.pa].join(' ')}>
          <Button
            color="green"
            value="Save Changes"
            block
            disabled={disabled}
            onClick={this.onClickHandler}
          />
        </div>
        <div ref={node => (this.popup = node)} />
      </div>
    );
  }
}

export default CreditCardInfo;
